import * as React from 'react';
import WearOSSelected from '../../../assets/wearos-selected.svg';
import WearOSUnselected from '../../../assets/wearos-unselected.svg';
import WearOSDisabledSelected from '../../../assets/wearos-disabled-selected.svg';
import WearOSDisabledUnselected from '../../../assets/wearos-disabled-unselected.svg';
import { IconProps } from '../../typescriptHelpers';

interface WearOSIconProps extends IconProps {
    isSelected: boolean;
    isDisabledTreatment: boolean;
}

const WearOSIcon: React.FC<WearOSIconProps> = (props: WearOSIconProps) => {
    let sourceImage = props.isSelected ? WearOSSelected : WearOSUnselected;
    if (props.isDisabledTreatment) {
        sourceImage = props.isSelected ? WearOSDisabledSelected : WearOSDisabledUnselected;
    }

    return <img src={sourceImage} width={props.width} height={props.height} />;
};

export default WearOSIcon;
